import { Card, Divider, List, ListItem, Popper, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CardIcon from '@material-ui/icons/CreditCard';
import NewFromTemplateIcon from '@material-ui/icons/FileCopyOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { BLUE, CREDENTIAL_ACTIONS, CREDENTIAL_CATEGORIES } from '../../_config/consts';
import * as UserAction from '../../redux/actions/user.actions';
import KeyOutlinedIconCustom from '../CustomIcons/KeyOutlinedIconCustom.jsx';
import PinIconCustom from '../CustomIcons/PinIconCustom.jsx';
import SmartPhoneKeyIconCustom from '../CustomIcons/SmartPhoneKeyIconCustom.jsx';

const styles = theme => ({
  buttonPositive: {
    color: BLUE,
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -15,
    marginRight: 10,
    width: 'max-content',
  },
});

@connect((state) => ({}))
class CredentialActionsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      anchorEl: null,
      isF9000Active: false,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const isF9000PluginActive = dispatch(UserAction.isF9000AddonActive());
    this.setState({ isF9000Active: isF9000PluginActive });
  }

  onOpenMenu(event) {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget, isOpen: true });
  }

  onCloseMenu(event) {
    event.stopPropagation();
    this.setState({ anchorEl: null, isOpen: false });
  }

  onActionClick(event, action) {
    event.stopPropagation();
    const { onActionSelect } = this.props;
    this.setState({ isOpen: false });
    if (onActionSelect) {
      onActionSelect(action);
    }
  }

  getActionsForCredentialType() {
    const { credentialType } = this.props;
    const { isF9000Active } = this.state;
    
    const actions = [];

    // Copy action is always available
    actions.push({
      key: 'copy',
      entity: 'useAsModel',
      icon: <NewFromTemplateIcon style={{ fontSize: 14, marginRight: 15, color: '#3f3f3f' }} />,
      action: CREDENTIAL_ACTIONS.COPY,
    });

    switch (credentialType) {
      case CREDENTIAL_CATEGORIES.MOBILE:
        actions.push({
          key: 'createCard',
          entity: 'copyAsNewCard',
          icon: <CardIcon style={{ fontSize: 15, marginRight: 15, color: '#3f3f3f' }} />,
          action: CREDENTIAL_ACTIONS.CREATE_CARD,
        });
        actions.push({
          key: 'createPin',
          entity: 'copyAsNewPIN',
          icon: <PinIconCustom style={{ width: 14, marginRight: 15, color: '#3f3f3f' }} />,
          action: CREDENTIAL_ACTIONS.CREATE_PIN,
        });
        break;
      case CREDENTIAL_CATEGORIES.RFID:
        actions.push({
          key: 'createMobile',
          entity: 'copyAsNewSmartphone',
          icon: <SmartPhoneKeyIconCustom style={{ width: 14, marginRight: 15, color: '#3f3f3f' }} />,
          action: CREDENTIAL_ACTIONS.CREATE_MOBILE,
        });
        actions.push({
          key: 'createPin',
          entity: 'copyAsNewPIN',
          icon: <PinIconCustom style={{ width: 14, marginRight: 15, color: '#3f3f3f' }} />,
          action: CREDENTIAL_ACTIONS.CREATE_PIN,
        });
        break;
      case CREDENTIAL_CATEGORIES.PIN:
        actions.push({
          key: 'createMobile',
          entity: 'copyAsNewSmartphone',
          icon: <SmartPhoneKeyIconCustom style={{ width: 14, marginRight: 15, color: '#3f3f3f' }} />,
          action: CREDENTIAL_ACTIONS.CREATE_MOBILE,
        });
        actions.push({
          key: 'createCard',
          entity: 'copyAsNewCard',
          icon: <CardIcon style={{ fontSize: 14, marginRight: 15, color: '#3f3f3f' }} />,
          action: CREDENTIAL_ACTIONS.CREATE_CARD,
        });
        break;
      case CREDENTIAL_CATEGORIES.F9000:
        actions.push({
          key: 'createMobile',
          entity: 'copyAsNewSmartphone',
          icon: <SmartPhoneKeyIconCustom style={{ width: 14, marginRight: 15, color: '#3f3f3f' }} />,
          action: CREDENTIAL_ACTIONS.CREATE_MOBILE,
        });
        actions.push({
          key: 'createCard',
          entity: 'copyAsNewCard',
          icon: <CardIcon style={{ fontSize: 14, marginRight: 15, color: '#3f3f3f' }} />,
          action: CREDENTIAL_ACTIONS.CREATE_CARD,
        });
        actions.push({
          key: 'createPin',
          entity: 'copyAsNewPIN',
          icon: <PinIconCustom style={{ width: 14, marginRight: 15, color: '#3f3f3f' }} />,
          action: CREDENTIAL_ACTIONS.CREATE_PIN,
        });
        break;
      default:
        break;
    }

    // Add F9000 action if the plugin is active (but not for F9000 type itself)
    if (isF9000Active && credentialType !== CREDENTIAL_CATEGORIES.F9000) {
      actions.push({
        key: 'createF9000',
        entity: 'copyAsNewF9000',
        icon: <KeyOutlinedIconCustom style={{ width: 14, marginRight: 15, color: '#3f3f3f' }} />,
        action: CREDENTIAL_ACTIONS.CREATE_F9000,
      });
    }

    return actions;
  }

  render() {
    const { isOpen, anchorEl } = this.state;
    const { buttonStyle, iconStyle, classes } = this.props;
    const actions = this.getActionsForCredentialType();

    return (
      <div
        onMouseEnter={(e) => this.onOpenMenu(e)}
        onMouseLeave={(e) => this.onCloseMenu(e)}
        >
        <Button
          onClick={(event) => {
            event.stopPropagation();
            this.onOpenMenu(event)
          }}
          className={classes.buttonPositive}
        >
          <Entity entity="actions" />
          <MoreVertIcon style={{ fontSize: 15, marginLeft: 5 }} />
        </Button>
        <Popper
          open={isOpen}
          anchorEl={anchorEl}
          disablePortal={false}
          placement="bottom-start"
          modifiers={{
            flip: {
              enabled: true,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'viewport',
            },
          }}
          style={{ zIndex: 9999, minWidth: 200, paddingTop: 5 }}
        >
          <Card style={{ backgroundColor: 'white' }}>
            <List component="nav" aria-label="credential actions">
              <ListItem key="actions-header" header style={{ backgroundColor: '#f0f0f0', marginTop: -10, height: 30 }}>
                <h5 style={{ margin: 0, fontSize: 10 }}><Entity entity="actions" /></h5>
              </ListItem>
              <Divider />
              {actions.map((actionItem) => (
                <ListItem
                  key={actionItem.key}
                  button
                  onClick={(e) => this.onActionClick(e, actionItem.action)}
                >
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 0 }}>
                    {actionItem.icon}
                    <h4 style={{ fontSize: 13, margin: 0, color: '#3f3f3f' }}>
                      <Entity entity={actionItem.entity} />
                    </h4>
                  </div>
                </ListItem>
              ))}
            </List>
          </Card>
        </Popper>
      </div>
    );
  }
}

export default withStyles(styles)(CredentialActionsMenu);